<div
  class="matterport-container"
  [nbSpinner]="loading"
  *ngIf="matterportModelSid; else noMatterport"
>
  <ngx-matterport-viewer
    #viewer
    *ngIf="!loading"
    [matterportModelSid]="matterportModelSid"
    (matterportConnected)="onMatterportConnected()"
    (mattertagSelected)="mattertagSelected$.next($event)"
    (mattertagHovered)="mattertagHovered$.next($event)"
    (mattertagDocked)="mattertagDocked$.next($event)"
  ></ngx-matterport-viewer>
</div>
<ng-template #noMatterport>
  <div class="no-matterport-container">
    <div class="image-area">
      <img src="assets/icons/matterport.svg" alt="" />
      <h3 i18n="@@matterport-oh-no">
        Oh no! You do not currently have a Matterport model associated with this
        asset
      </h3>
    </div>
  </div>
</ng-template>
